import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "options", "searchable", "placeHolder", "disabled", "onChange", "topHolder", "renderOption", "selectedOption", "value"];
import React from "react";
var __jsx = React.createElement;
import { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import stl from "./SelectTwo.module.css";
import { ucWords } from "@/utils/stringHelpers";
var SelectTwo = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref2, _selectedOption$label;
  var className = _ref.className,
    options = _ref.options,
    _ref$searchable = _ref.searchable,
    searchable = _ref$searchable === void 0 ? [] : _ref$searchable,
    placeHolder = _ref.placeHolder,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    topHolder = _ref.topHolder,
    renderOption = _ref.renderOption,
    selectedOption_raw = _ref.selectedOption,
    value = _ref.value,
    additionalProps = _objectWithoutProperties(_ref, _excluded);
  var inputRef = useRef(null);
  var _useState = useState(options),
    filteredOptions = _useState[0],
    setFilteredOptions = _useState[1];
  var _useState2 = useState(selectedOption_raw),
    selectedOption = _useState2[0],
    setSelectedOption = _useState2[1];
  var selectedOptLabel = ucWords((_ref2 = (_selectedOption$label = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) !== null && _selectedOption$label !== void 0 ? _selectedOption$label : (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || (value === null || value === void 0 ? void 0 : value.label)) !== null && _ref2 !== void 0 ? _ref2 : "");
  var _useState3 = useState(selectedOptLabel),
    searchText = _useState3[0],
    setSearchText = _useState3[1];
  var _useState4 = useState(-1),
    highlightedIndex = _useState4[0],
    setHighlightedIndex = _useState4[1];
  var _useState5 = useState(false),
    isDropdownOpen = _useState5[0],
    setIsDropdownOpen = _useState5[1];
  var _useState6 = useState(null),
    prevSelectedOption = _useState6[0],
    setPrevSelectedOption = _useState6[1];
  var containerRef = useRef(null);
  var handleInputBlur = function handleInputBlur() {
    if (selectedOption) {
      setSearchText(selectedOption.label);
    } else if (prevSelectedOption) {
      setSelectedOption(prevSelectedOption);
      setSearchText(prevSelectedOption.label);
      if (onChange) onChange(prevSelectedOption);
    } else {
      setSelectedOption(null);
      setSearchText("");
      if (onChange) onChange(null);
    }
    setFilteredOptions(options);
    setIsDropdownOpen(false);
  };
  useEffect(function () {
    var _selectedOption_raw$l;
    setSearchText((_selectedOption_raw$l = selectedOption_raw === null || selectedOption_raw === void 0 ? void 0 : selectedOption_raw.label) !== null && _selectedOption_raw$l !== void 0 ? _selectedOption_raw$l : "");
    setSelectedOption(selectedOption_raw);
  }, [selectedOption_raw === null || selectedOption_raw === void 0 ? void 0 : selectedOption_raw.id]);
  useEffect(function () {
    if (selectedOption) {
      setPrevSelectedOption(selectedOption);
    }
  }, [selectedOption]);
  useEffect(function () {
    var _inputRef$current;
    if (!selectedOption) return;
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.blur();
  }, [selectedOption]);
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(function () {
    // Filter options based on search text for User Input only  & ignore the selected option for first render
    if (!isDropdownOpen || searchText.trim() === "" || selectedOptLabel === searchText) {
      setFilteredOptions(options);
    } else {
      var lowerSearch = searchText.toLowerCase();
      setFilteredOptions(options.filter(function (option, index) {
        var _searchable$index;
        var searchableLabel = ((_searchable$index = searchable[index]) === null || _searchable$index === void 0 ? void 0 : _searchable$index.label) || "";
        return option.label.toLowerCase().startsWith(lowerSearch) || searchableLabel.toLowerCase().startsWith(lowerSearch);
      }));
    }
    setHighlightedIndex(-1);
  }, [searchText, searchable]);
  useImperativeHandle(ref, function () {
    return {
      reset: function reset() {
        setSearchText("");
        setSelectedOption(null);
        setFilteredOptions(options);
        setHighlightedIndex(-1);
        setIsDropdownOpen(false);
      }
    };
  });
  var handleInputChange = function handleInputChange(e) {
    setSearchText(ucWords(e.target.value));
    setIsDropdownOpen(true);
    if (e.target.value.trim() === "") {
      setSelectedOption(null); // Only reset selectedOption if input is cleared
      onChange === null || onChange === void 0 ? void 0 : onChange(null);
    }
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (!isDropdownOpen) return;
    switch (e.key) {
      case "ArrowDown":
        setHighlightedIndex(function (prevIndex) {
          return prevIndex < filteredOptions.length - 1 ? prevIndex + 1 : prevIndex;
        });
        break;
      case "ArrowUp":
        setHighlightedIndex(function (prevIndex) {
          return prevIndex > 0 ? prevIndex - 1 : prevIndex;
        });
        break;
      case "Enter":
        if (highlightedIndex >= 0 && highlightedIndex < filteredOptions.length) {
          var _selectedOption = filteredOptions[highlightedIndex];
          setSearchText(_selectedOption.label);
          setSelectedOption(_selectedOption);
          setIsDropdownOpen(false);
          setFilteredOptions(options);
          if (onChange) onChange(_selectedOption);
        }
        break;
      case "Escape":
        setIsDropdownOpen(false);
        break;
    }
  };
  var handleOptionClick = function handleOptionClick(option) {
    setPrevSelectedOption(option); // Store the previous valid selection
    setSearchText(option.label);
    setSelectedOption(option);
    setFilteredOptions(options);
    setIsDropdownOpen(false);
    if (onChange) {
      onChange(option);
    }
  };
  var handleInputFocus = function handleInputFocus() {
    setFilteredOptions(options);
    setIsDropdownOpen(true);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: [stl.SelectTwo, className !== null && className !== void 0 ? className : undefined, disabled ? stl.disabled : undefined, !selectedOption ? stl.emptyWrapper : undefined].join(" "),
    ref: containerRef
  }, (searchText !== "" || isDropdownOpen) && /*#__PURE__*/React.createElement("i", {
    className: [stl.searcIcon, stl.blueSearchIcon].join(" ")
  }), /*#__PURE__*/React.createElement("input", _extends({
    ref: inputRef,
    className: stl.input,
    type: "text",
    value: ucWords(searchText),
    onChange: handleInputChange,
    onKeyDown: handleKeyDown,
    onFocus: handleInputFocus,
    onBlur: handleInputBlur // Ensure blur functionality works
  }, additionalProps)), /*#__PURE__*/React.createElement("label", {
    className: [stl.placeHolder, searchText !== "" ? stl.toTopLabel : undefined].join(" ")
  }, /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("span", null, searchText === "" ? !isDropdownOpen ? placeHolder : "" : topHolder)), isDropdownOpen && filteredOptions.length > 0 && /*#__PURE__*/React.createElement("ul", {
    role: "listbox",
    className: stl.dropdownList,
    onMouseDown: function onMouseDown(e) {
      return e.preventDefault();
    } // Prevent onBlur trigger
  }, filteredOptions.map(function (option, index) {
    return /*#__PURE__*/React.createElement("li", {
      role: "option",
      tabIndex: 0,
      "aria-selected": option.id === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id),
      className: stl.dropdownItem,
      key: option.id,
      onClick: function onClick(e) {
        e.stopPropagation();
        handleOptionClick(option);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleOptionClick(option);
        }
      },
      style: {
        backgroundColor: index === highlightedIndex ? "#f0f0f0" : "white"
      }
    }, (option === null || option === void 0 ? void 0 : option.image) && /*#__PURE__*/React.createElement("div", {
      className: stl.imageHolder
    }, /*#__PURE__*/React.createElement("img", {
      src: option === null || option === void 0 ? void 0 : option.image,
      alt: option.label,
      width: "10px",
      height: "10px"
    })), ucWords(option.label));
  })));
});
export default SelectTwo;